import React from "react";
import style from "./workingFile.module.scss";

function Footer() {
  return (
    <>
      <div className={`${style.footer}`}>
        <div>
          <div className={`${style.hr}`}></div>

          <p className="text-center mt-3" style={{ fontSize: "12px" }}>
            <span>
              2nd Floor, SOFTWARE TECHNOLOGY PARKS OF INDIA, No. 5, SH 49A,
              Tharamani, Chennai, Tamil Nadu 600113.
            </span>
          </p>
        </div>
        <div className="d-flex align-items-center">
          <div className={style.footer1}>
            <div className={style.greensmall}></div>
            <div className={style.greenbig}></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
